import { ReactElement } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { MobileAboutUsScreen } from './MobileAboutUsScreen'
import { WebAboutUsScreen } from './WebAboutUsScreen'
import { URLS } from '../../content/urls'

export interface AboutUsScreenData {
  backgroundUrls: string[]
}

export const AboutUsScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)

  const screenData = { backgroundUrls: URLS.aboutUsBackgrounds }

  return isMobile ? (
    <MobileAboutUsScreen data={screenData} />
  ) : (
    <WebAboutUsScreen data={screenData} />
  )
}
